var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBritishColumbia(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M0,256C0,114.616,114.616,0,256,0s256,114.616,256,256H0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "189.217,242.005 175.222,256 189.217,256  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "322.783,242.006 322.783,256 336.777,256  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M7.386,194.784C2.571,214.4,0,234.899,0,256h80.777l61.216-61.216H7.386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M370.005,194.784L431.221,256H512c0-21.101-2.572-41.6-7.386-61.216H370.005z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "354.264,194.784 322.783,194.784 322.783,194.784 383.999,256 415.481,256  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "189.217,226.263 189.217,194.784 189.215,194.784 127.999,256 159.481,256  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M119.922,39.142C109.37,45.778,99.337,53.16,89.896,61.217h52.1L119.922,39.142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M422.104,61.217c-9.441-8.058-19.473-15.44-30.024-22.075l-22.074,22.075H422.104z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M289.391,161.391h204.55c-9.678-24.319-22.98-46.797-39.233-66.783H289.392h-0.001V2.167 C278.461,0.744,267.317,0,256,0c-11.319,0-22.461,0.744-33.391,2.167v92.44v0.001H57.292 c-16.253,19.986-29.555,42.464-39.233,66.783h204.548h0.001V256h66.783v-94.608V161.391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M189.217,61.217v-0.001l-38.593-38.593c-7.135,3.227-14.089,6.782-20.856,10.625l27.969,27.969 H189.217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M322.783,61.217L322.783,61.217l38.594-38.593c-7.341-3.319-14.868-6.295-22.558-8.924 l-16.036,16.037V61.217z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M512,256c0,141.384-114.616,256-256,256S0,397.384,0,256C11.13,256,512,256,512,256z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M469.33,288.65c-21.333,0-21.333-19.506-42.667-19.506c-21.333,0-21.333,19.506-42.665,19.506 s-21.333-19.506-42.665-19.506c-21.333,0-21.333,19.506-42.667,19.506s-21.335-19.506-42.67-19.506 c-21.333,0-21.333,19.506-42.665,19.506c-21.33,0-21.33-19.506-42.663-19.506c-21.335,0-21.335,19.506-42.67,19.506 s-21.335-19.506-42.67-19.506c-21.33,0-21.33,19.506-42.663,19.506c-21.218,0-21.341-19.291-42.332-19.497 c0.591,11.71,1.989,23.206,4.103,34.448c17.004,2.499,18.493,19.182,38.23,19.182c21.333,0,21.333-19.504,42.663-19.504 c21.335,0,21.335,19.504,42.67,19.504s21.335-19.504,42.67-19.504c21.333,0,21.333,19.504,42.663,19.504 c21.333,0,21.333-19.504,42.665-19.504c21.335,0,21.335,19.504,42.67,19.504c21.335,0,21.335-19.504,42.667-19.504 c21.333,0,21.333,19.504,42.665,19.504s21.333-19.504,42.665-19.504c21.335,0,21.335,19.504,42.667,19.504 c19.739,0,21.228-16.682,38.233-19.181c2.115-11.243,3.511-22.738,4.105-34.448C490.674,269.361,490.549,288.65,469.33,288.65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M426.663,335.927c-21.333,0-21.333,19.506-42.665,19.506s-21.333-19.506-42.665-19.506 c-21.333,0-21.333,19.506-42.667,19.506c-21.335,0-21.335-19.506-42.67-19.506c-21.333,0-21.333,19.506-42.665,19.506 c-21.33,0-21.33-19.506-42.663-19.506c-21.335,0-21.335,19.506-42.67,19.506s-21.335-19.506-42.67-19.506 c-21.33,0-21.33,19.506-42.663,19.506c-15.243,0-19.597-9.956-28.622-15.644c6.008,17.359,13.824,33.872,23.237,49.308 c1.637,0.302,3.419,0.469,5.385,0.469c21.333,0,21.333-19.504,42.663-19.504c21.335,0,21.335,19.504,42.67,19.504 s21.335-19.504,42.67-19.504c21.333,0,21.333,19.504,42.663,19.504c21.333,0,21.333-19.504,42.665-19.504 c21.335,0,21.335,19.504,42.67,19.504c21.335,0,21.335-19.504,42.667-19.504c21.333,0,21.333,19.504,42.665,19.504 s21.333-19.504,42.665-19.504c21.335,0,21.335,19.504,42.667,19.504c1.967,0,3.75-0.167,5.387-0.47 c9.413-15.435,17.229-31.948,23.239-49.306c-9.026,5.685-13.38,15.643-28.626,15.643 C447.998,355.433,447.998,335.927,426.663,335.927z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M511.862,247.957c0.022,0.711,0.047,1.422,0.063,2.136 C511.909,249.38,511.883,248.668,511.862,247.957z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M0.075,250.092c0.017-0.713,0.041-1.424,0.063-2.136C0.117,248.668,0.091,249.38,0.075,250.092z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M0,256c0-1.975,0.03-3.942,0.075-5.908C0.029,252.058,0,254.025,0,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M0,256c0,4.663,0.132,9.296,0.381,13.897c20.943,0.235,21.082,19.494,42.285,19.494 c21.333,0,21.333-19.504,42.663-19.504c21.335,0,21.335,19.504,42.67,19.504s21.335-19.504,42.67-19.504 c21.333,0,21.333,19.504,42.663,19.504c21.333,0,21.333-19.504,42.665-19.504c21.335,0,21.335,19.504,42.67,19.504 c21.335,0,21.335-19.504,42.667-19.504c21.333,0,21.333,19.504,42.665,19.504s21.333-19.504,42.665-19.504 c21.335,0,21.335,19.504,42.667,19.504c21.205,0,21.344-19.259,42.291-19.494C511.868,265.295,512,260.663,512,256H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M511.925,250.092C511.97,252.056,512,254.024,512,256C512,254.025,511.971,252.058,511.925,250.092z "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M426.663,402.709c-21.333,0-21.333,19.506-42.665,19.506s-21.333-19.506-42.665-19.506 c-21.333,0-21.333,19.506-42.667,19.506c-21.335,0-21.335-19.506-42.67-19.506c-21.333,0-21.333,19.506-42.665,19.506 c-21.33,0-21.33-19.506-42.663-19.506c-21.335,0-21.335,19.506-42.67,19.506s-21.335-19.506-42.67-19.506 c-14.734,0-19.293,9.304-27.733,15.061c22.389,27.426,50.359,50.11,82.164,66.352L256,478.266l116.24,5.855 c31.804-16.243,59.774-38.924,82.163-66.35C445.959,412.015,441.4,402.709,426.663,402.709z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M397.983,408.814l-77.875,14.895l-9.866-78.665L256,402.899l-54.24-57.856l-9.87,78.665 l-77.871-14.895l38.189,69.452l-12.472,5.866C174.624,501.949,214.137,512,256,512s81.376-10.051,116.264-27.867l-12.467-5.865 L397.983,408.814z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBritishColumbia);
export default __webpack_public_path__ + "static/media/british-columbia.c0f945e9ccf49a1d0dca67a509941e4b.svg";
export { ForwardRef as ReactComponent };